import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { IGrammarInUse, IGrammarInUseContent } from 'src/app/interfaces/resource';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { GrammarInUseStore } from 'src/app/stores/resources/grammarInUse';

@Component({
  selector: 'app-grammar-content-form',
  templateUrl: './grammar-content-form.component.html',
  styleUrls: ['./grammar-content-form.component.scss']
})
export class GrammarContentFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  @ViewChild('coverFile', {static:false}) coverFile: ElementRef;

  ITEM_KEY: any;
  LESSON_KEY:any;
  SECTION_KEY:any;
  LESSON:any;
  SECTION:any;

  ITEM: IGrammarInUseContent;
  TITLE: any = "Add new grammar content"

  form: FormGroup;
  name: AbstractControl;
  description: AbstractControl;
  content: AbstractControl;
  title:AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  LOADING = true;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: GrammarInUseStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private storage: FireStorageService
  ) { }


  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), this.auth.selectedCompanyKey, COLLECTION_NAME.GRAMMAR_IN_USE, "name")],
      description: [null],
      content:[null],
      title:[null,Validators.required],
    })
    this.route.params.subscribe(async param => {
      const { id,lessonKey,sectionKey } = param;
      this.LESSON_KEY=lessonKey;
      this.SECTION_KEY=sectionKey;
      this.LESSON = await this.store.fetchSelectedLesson(this.LESSON_KEY)
      this.SECTION = await this.store.fetchSelectedLesson(this.SECTION_KEY)
      if (!this.SECTION || !this.LESSON) {
        this.router.navigate([`/404`])
        return;
      }
      if (id !== 'draft') {
        this.ITEM_KEY = param.id;
        this.store.fetchSelectedContent(this.SECTION_KEY, this.ITEM_KEY, (doc: IGrammarInUseContent) => {
          if (doc) {
            this.TITLE = "Edit grammar content"
            this.ITEM = doc;
            this.form = this.fb.group({
              name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), this.auth.selectedCompanyKey, COLLECTION_NAME.LESSON, "name", this.ITEM.name)],
              description: [null],
              content:[null],
              title:[null,Validators.required]
            })
            const { name, description,content,title } = doc;
            this.form.patchValue({
              name, description,content,title
            })
            this.inputEl.nativeElement.focus();
            this.LOADING = false;
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/grammar-in-use/section/${lessonKey}/${sectionKey}`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.LOADING = false;
      }
    })
  }

  async onSave(f: any, isDraft: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.error = null;
      this.form.disable();
      const { name, description,content,title } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.draft : STATUS_OBJECT.submitted;
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();

      const item: IGrammarInUseContent = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        content,
        title,
        lessonKey:this.LESSON_KEY,
        lessonRef:this.ds.grammarInUseRef().doc(this.LESSON_KEY).ref,
        sectionKey:this.SECTION_KEY,
        sectionRef:this.ds.grammarInUseRef().doc(this.SECTION_KEY).ref,
      }
      this.store.addContent(item, (success, res) => {
        if (success) {
          this.snackBar.open("Grammar in Use content has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (this.ITEM_KEY) {
          this.router.navigate([`/grammar-in-use/section/${this.LESSON_KEY}/${this.SECTION_KEY}`])
        }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    this.router.navigate([`/grammar-in-use/section/${this.LESSON_KEY}/${this.SECTION_KEY}`])
  }

}
